import Vue from 'vue';
import VueUpload from 'vue-upload-component';

Vue.component('file-upload', VueUpload);
